import React from 'react';
import { LargeProductCard } from './LargeProductCard';
import { MediumProductCard } from './MediumProductCard';
import { CTAContentProductCard } from './CTAContentProductCard';
export var ContentProductCard = function ContentProductCard(_ref) {
  var position = _ref.position,
    product = _ref.product,
    variant = _ref.variant,
    tag = _ref.tag,
    onAction = _ref.onAction,
    following = _ref.following,
    onFollow = _ref.onFollow,
    withSPA = _ref.withSPA,
    context = _ref.context,
    _ref$distributorsWhit = _ref.distributorsWhiteList,
    distributorsWhiteList = _ref$distributorsWhit === void 0 ? [] : _ref$distributorsWhit;
  switch (variant) {
    case 'medium':
      return React.createElement(MediumProductCard, {
        position: position,
        product: product,
        onAction: onAction,
        tag: tag,
        following: following,
        onFollow: onFollow,
        withSPA: withSPA,
        context: context,
        distributorsWhiteList: distributorsWhiteList
      });
    case 'cta':
      return React.createElement(CTAContentProductCard, {
        position: position,
        product: product,
        onAction: onAction,
        tag: tag,
        following: following,
        onFollow: onFollow,
        withSPA: withSPA,
        context: context,
        distributorsWhiteList: distributorsWhiteList
      });
    case 'large':
    default:
      return React.createElement(LargeProductCard, {
        position: position,
        product: product,
        onAction: onAction,
        tag: tag,
        following: following,
        onFollow: onFollow,
        withSPA: withSPA,
        context: context,
        distributorsWhiteList: distributorsWhiteList
      });
  }
};